/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { InventoryDestroyPathParams, InventoryDestroyResponse } from '../types/InventoryDestroy'

/**
 * DELETE /:organisation/inventory/:item
 * @see backend/nexus/modules/Billing/Http/Controllers/InventoryController.php InventoryController::destroy
 */
export async function inventoryDestroy(
	organisation: InventoryDestroyPathParams['organisation'],
	item: InventoryDestroyPathParams['item'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<InventoryDestroyResponse>> {
	return axiosInstance.delete(`/${organisation}/inventory/${item}`, config)
}
